import { Box, Typography } from "@mui/material";
import { SettingsIcon, ListIcon, PreviewIcon } from "../icons";
import React, { useEffect, useRef, useState } from "react";
import { Drawer } from "./ProjectSettingPage";
import { t } from "i18next";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { isCreatingReportState, overviewClassListState, selectedReportListState } from "../recoil";
import { getProject } from "../services/projectService";
import { useParams } from "react-router-dom";
import { ContentBoxStyle } from "../styles/GlobalStyles";
import DetailContent from "../components/report/DetailContent";
import SettingContent from "../components/report/SettingContent";
import SampleContent from "../components/report/SampleContent";
import { useColorTheme } from "../components/report/setting/ColorThemeContext";
import { REPORT_CONTENTS } from "../components/report/ReportContents";
import { getReportConfig } from "../services/reportService";

export default function ProjectReportPage() {
  const { id } = useParams();
  const listItems = [
    { icon: <PreviewIcon />, menu: t("Sample") },
    { icon: <ListIcon />, menu: t("Detail") },
    { icon: <SettingsIcon />, menu: t("Setting"), id: "report-setting-menu" },
  ];
  const [selectedItem, setSelectedItem] = useState(t("Detail"));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [classList, setClassList] = useState<string[]>([]);
  const setSelectedReportList = useSetRecoilState(selectedReportListState);
  const { setSelectedTheme, colorThemes } = useColorTheme();
  const setIsCreatingReport = useSetRecoilState(isCreatingReportState);
  const [config, setConfig] = useState<reportConfigItem | null>({
    name: "",
    date_range: { start_date: "", end_date: "" },
    color_theme: "",
    class_filter: null,
    contents: "",
  });
  const [type, setType] = useState<string>("분석");
  // const [config, setConfig] = useState<reportConfigItem | null>(null);

  useEffect(() => {
    if (config?.color_theme && config.color_theme in colorThemes) {
      setSelectedTheme(config.color_theme);
      // console.log(config.color_theme);
    } else {
      setSelectedTheme("default");
    }
  }, [config, colorThemes]);

  const fetchReportConfig = async () => {
    setIsCreatingReport(false);
    try {
      const response = await getReportConfig(Number(id));
      if (response.reportConfig) {
        setIsCreatingReport(!!response.reportConfig.contents);
        setConfig(response.reportConfig);
        // 구버전 항목(번역 문자열 type)은 현재 구성에 없으므로 제외
        const contents = JSON.parse(response.reportConfig.contents || "[]").filter((item: any) => item.type in REPORT_CONTENTS);
        const contentsWithIds = contents.map((item: any) => {
          const uniqueRandomNumber = String(Math.floor(100000 + Math.random() * 900000));
          return {
            ...item,
            id: `${item.type}-${uniqueRandomNumber}`,
          };
        });
        setSelectedReportList(contentsWithIds);
      } else {
        setSelectedReportList([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchReportConfig();
  }, []);

  useEffect(() => {
    const getProjectData = async () => {
      try {
        const response = await getProject(Number(id));
        setType(response.project.step);
        setClassList(response.project.class);
      } catch (error) {
        console.error(error);
      }
    };
    getProjectData();
  }, []);

  return (
    <div className="h-full flex overflow-hidden">
      <Box sx={{ width: "180px", flexShrink: 0, height: "100%" }}>
        <Drawer listItems={listItems} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
      </Box>
      <Box sx={{ flex: 1, overflow: "auto", p: "16px" }}>
        <Box sx={ContentBoxStyle}>
          {!isLoading && (
            <>
              {selectedItem === t("Sample") && <SampleContent />}
              {selectedItem === t("Detail") && <DetailContent config={config} setConfig={setConfig} type={type} />}
              {selectedItem === t("Setting") && (
                <SettingContent classList={classList} setConfig={setConfig} config={config} />
              )}
            </>
          )}
        </Box>
      </Box>
    </div>
  );
}
